import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../../components/Layout/Layout';
import StatusBadge from '../../../components/StatusBadge/StatusBadge';
import api from '../../../api/axios';
import './MyTrainings.css';

export default function MyTrainings() {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/user-trainings/my').then(res => setTrainings(res.data)).finally(() => setLoading(false));
  }, []);

  function isOverdue(deadline, status) {
    if (!deadline || status === 'passed') return false;
    return new Date(deadline) < new Date();
  }

  if (loading) return <Layout title="Meine Schulungen"><div>Laden...</div></Layout>;

  return (
    <Layout title="Meine Schulungen">
      <div className="my-trainings-grid">
        {trainings.map(t => {
          const overdue = isOverdue(t.deadline, t.status);
          return (
            <div key={t.id} className="my-training-card">
              <div className="my-training-card-header">
                <h3 className="my-training-card-title">{t.title}</h3>
                <StatusBadge status={t.status} />
              </div>
              {t.description && <p className="my-training-card-desc">{t.description.substring(0, 80)}...</p>}
              <div className="my-training-card-meta">
                {t.deadline && (
                  <span style={{ color: overdue ? 'var(--error)' : 'var(--gray-dark)', fontWeight: overdue ? 600 : 400 }}>
                    {overdue ? '⚠ Überfällig: ' : 'Frist: '}
                    {new Date(t.deadline).toLocaleDateString('de-DE')}
                  </span>
                )}
                {t.attemptCount > 0 && <span>{t.attemptCount} Versuch{t.attemptCount !== 1 ? 'e' : ''}</span>}
                {t.lastScore != null && <span>Letzte Note: {parseFloat(t.lastScore).toFixed(0)}%</span>}
              </div>
              <Link to={`/my-trainings/${t.id}`} className="btn btn-primary btn-sm" style={{ marginTop: 'auto' }}>
                {t.status === 'passed' ? 'Schulung ansehen' : 'Zur Schulung'}
              </Link>
            </div>
          );
        })}
        {trainings.length === 0 && (
          <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--gray-dark)', gridColumn: '1/-1' }}>
            Ihnen wurden noch keine Schulungen zugewiesen.
          </div>
        )}
      </div>
    </Layout>
  );
}
